module.exports = __webpack_public_path__ + "img/wallet-report-red.8f55f0a5.svg";